<template>
  <div>
    <NewClassification @created="getClassifications" />
    <ViewClassification
      :classification="classification"
      @updated="getClassifications"
      @close="classification = null"
    />
    <div class="row">
      <div
        class="
          col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
          pr-0
          d-flex
          align-items-center
        "
      >
        <h1 class="title-pages">CLASSIFICAÇÕES</h1>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pl-0 text-right pl-0"
      >
        <v-btn
          v-if="permission('write', 'financial_provider')"
          @click="$bvModal.show('new_classification')"
          class="btn-add m-1"
          ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn
        >
      </div>
      <div class="col-md-3">
        <label>Status</label>
        <select
          v-model="active"
          class="form-control"
          @change="getClassifications"
        >
          <option
            v-for="(item, key) in active_filters"
            :key="key"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="col-md-9">
        <label>Pesquisar</label>
        <input class="form-control" v-model="search" />
      </div>
    </div>
    <div class="v-clean p-5 text-center" v-show="classifications.length == 0">
      <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
    </div>
    <v-data-table
      v-show="classifications.length > 0"
      dense
      :headers="headers"
      :items="classifications"
      :search="search"
      :footer-props="{
        'items-per-page-options': [50, 75, 100],
        'items-per-page-text': 'Mostrar',
      }"
    >
      <template #[`item.active`]="{ item }">
        {{ item.active ? "ATIVO" : "INATIVO" }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="classification = item" class="btn-edit m-1">
          <i class="fas fa-pen mr-2 text-twenty"></i>
          EDITAR
        </v-btn>
      </template>
    </v-data-table>
    <errors-messages :errors="errors" />
  </div>
</template>

<script>
import NewClassification from "./NewClassification.vue";

import ViewClassification from "./ViewClassification.vue";

import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import permission from "../../../lib/permission";

import api from "../../../services/api";

export default {
  name: "Classifications",

  components: { NewClassification, ViewClassification, ErrorsMessages },

  data() {
    return {
      errors: [],
      loading: false,

      active_filters: [
        { text: "ATIVO", value: "1" },
        { text: "INATIVO", value: "0" },
      ],
      active: "1",

      search: "",
      headers: [
        { text: "NOME", value: "name" },
        { text: "ESTADO", value: "active" },
        { text: "AÇÕES", value: "actions" },
      ],
      classifications: [],

      classification: null,
    };
  },

  created() {
    this.getClassifications();
  },

  methods: {
    permission,

    async getClassifications() {
      try {
        this.loading = true;

        const params = { active: this.active };
        const response = await api.get("/rest-home/providers/classifications", {
          params,
        });
        const { error, errors, classifications } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.classifications = classifications;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>